import { AssetRequestType } from "./constants";
import { createAsset } from "./createAsset";

export const createFolder = (name: string, path?: string) => {
  return {
    ...createAsset(name, path),
    requestType: AssetRequestType.UPLOAD,
    isFolder: true,
  };
};
